import _ from 'lodash';

import ChatMessage from 'models/chat_message';
import Communicator from 'models/communicator';
import ConversationItem from 'models/conversation_item';

export default function createAgentChatMessage({
  agentProfile,
  content,
  conversationId,
  customerId,
  snippetIds = [],
  relatedSnippetIds = [],
}) {
  return ConversationItem.create({
    conversationId,
    content: new ChatMessage(_.merge({ sentAt: new Date().toISOString(), participantId: agentProfile.id }, content)),
    customerId,
    initiator: { type: Communicator.AGENT, id: agentProfile.id },
    snippetIds,
    relatedSnippetIds,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/conversation_item/create_agent_chat_message.js